export const resolveABTestData = (getProductList, products, filters) => {
    try {
        return typeof getProductList === 'function' ? getProductList(products, filters) : { products };
    } catch (e) {
        return { products };
    }
};
